import React from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  NavLink,
} from "reactstrap";
import { Link } from "react-router-dom";
import logowhite from "../img/logo.png";
import logoCIEBA from "../img/logoCIEBA.png";
import store from "./Stores/SurveyStore";
import userStore from "./Stores/UserStore";
import ibsStore from "./Stores/IbsSurveyStore";
import sharedStore from "./Stores/SharedStore";
import { observer } from "mobx-react";
import { changeSurveyCtrl, validateAdminOnlyCtrl } from "../control";
import "../Styling/NavMenu.css";
import { pageNameDisplayOverride } from "../helpers";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { toast } from "react-toastify";
import { CURRENT_DATA_YEAR, SurveyTypeURL } from "../Enums/constants";
import { getIbsAccountInfo, checkIfAnalyst } from "../Services/IBS/IbsService";
import { showTemplates, isUK } from "../ibsHelper";
import UserStore from "./Stores/UserStore";
import { getSurveyResponseValue } from "../Helpers/General/SurveyResponsesHelper";

const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
};
 
const NavMenu = observer(() => {
    store.availPageTitles.length = 0;
    const surveyTypeUrl = store.surveyTypeUrl.toLowerCase();
    const isPabsSurveyType =
        surveyTypeUrl === SurveyTypeURL.PABS_LG
        || surveyTypeUrl === SurveyTypeURL.PABS_UK
        || surveyTypeUrl === SurveyTypeURL.PABS;
    const isIbsSurveyType =
        surveyTypeUrl === SurveyTypeURL.DB
        || surveyTypeUrl === SurveyTypeURL.DC
        || surveyTypeUrl === SurveyTypeURL.IBS;

    const handleYearChange = async e => {
        ibsStore.mandateData = []
        let orgId = isPabsSurveyType ? store.currentSurvey?.SystemId : ibsStore.currentSurvey?.PlanID;

        //store.loadingSurvey = true; wanted to give loading screen but only if diff product
        let newYear = e.target.value.dataYear.replace(e.target.value.productID, '');
        await changeSurveyCtrl(e.target.value.surveyId, orgId, e.target.value.productID);
    };

    let handlePlanChangePABS = async e => {
        let availableSurveysWithPlan = store.allAvailableSurveys.filter((survey) => { return survey.SystemId === e.target.value.PlanId });
        if (availableSurveysWithPlan && availableSurveysWithPlan?.length > 0) {

            // Select most up to date survey currently available
            let surveyToSwitchTo = availableSurveysWithPlan[0];
            for (let survey of availableSurveysWithPlan) {
                if (survey.DataYear > surveyToSwitchTo.DataYear) { surveyToSwitchTo = survey;  }
            }

            await changeSurveyCtrl(surveyToSwitchTo.SurveyId, e.target.value.PlanId);
        }

    };

    const triggerQuestionMode = () => {
        store.questionMode = !store.questionMode;
        store.analystMode = false;
    };

    const triggerAnalystMode = () => {
        store.analystMode = !store.analystMode;
        store.questionMode = false;
    };
    const triggerDeveloperMode = () => {
        store.developerMode = !store.developerMode;
    };

    const triggerValidateForAdmin = () => {
        toast("Validating in admin mode... Please wait.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            draggable: false,
            autoClose: 4000,
            hideProgressBar: true,
            className: "info-notif",
        });
        validateAdminOnlyCtrl(store.currentLandedPage, "en");
    };

    const triggerHelpModal = () => {
        sharedStore.showHelpModal = !sharedStore.showHelpModal;
    };

    const triggerAdminPanel = () => {
        store.showAdminPanel = !store.showAdminPanel;
    };
    const triggerLogoutPanel = () => {
        store.showLogoutModal = !store.showLogoutModal;
    };
    const triggerPrintPanel = () => {
        store.showPrintModal = !store.showPrintModal;
    };

    var currentDataYear;
    let availableDataYears = [];
    let surveyYearAddition =
        ibsStore?.currentSurvey?.ReturnMonth === 3 ||
            ibsStore?.currentSurvey?.ReturnMonth === 6
            ? 1
            : 0;

    if (window.location.href.includes("/pabs")) {
        store.availableSurveys &&
            store.availableSurveys.map(function (key) {
                currentDataYear = store.currentSurvey?.DataYear;
                var suffix = "";
                if (key.SurveyTypeId === 1) {
                    suffix = "NL";
                }
                if (key.SurveyTypeId === 6) {
                    suffix = "LG";
                }
                if (store.currentSurvey?.SurveyTypeId == 5 && key.DataYear >= 2019) {
                    availableDataYears.push({
                        surveyId: key.SurveyId,
                        dataYear: key.DataYear + surveyYearAddition + suffix,
                    });
                } else if (store.currentSurvey?.SurveyTypeId != 5) {
                    availableDataYears.push({
                        surveyId: key.SurveyId,
                        dataYear: key.DataYear + surveyYearAddition + suffix,
                    });
                }
            });
    } else {
        if (ibsStore.currentSurvey)
            currentDataYear = ibsStore.currentSurvey?.DataYear;
        else currentDataYear = sharedStore.currentDataYear;
        //TODO: We should do this in the backend instead. Filtering on frontend like before. Will refactor this portion as it is becoming messy.
        let productsForUser = [];
        store.availablePlanProducts.map(function (item, i) {
            productsForUser.push(item.ProductID); //get list of products available
        });
        var DCSurveys = store.allAvailableSurveys.filter(
            (survey) =>
                survey.ProductID == 2 &&
                ibsStore.currentSurvey?.PlanID == survey.PlanID &&
                productsForUser.includes(2)
        );
        var DBSurveys = store.allAvailableSurveys.filter(
            (survey) =>
                survey.ProductID == 1 &&
                ibsStore.currentSurvey?.PlanID == survey.PlanID &&
                productsForUser.includes(1)
        );
        let surveysAvailable = store.allAvailableSurveys.filter(
            (survey) =>
                ibsStore.currentSurvey?.PlanID == survey.PlanID &&
                ((userStore.accountInfo && userStore.accountInfo.isAnalyst) ||
                    (ibsStore.accountInfo && ibsStore.accountInfo.UserRoleID == 3) ||
                    productsForUser.includes(survey.ProductID))
        );
        surveysAvailable = surveysAvailable.sort((a, b) =>
            a.DataYear > b.DataYear ? 1 : -1
        );
        surveysAvailable = surveysAvailable.sort((a, b) =>
            a.ProductID > b.ProductID ? 1 : -1
        );

        let firstDC = surveysAvailable.findIndex((elem) => elem.ProductID == 2);
        let firstDB = surveysAvailable.findIndex((elem) => elem.ProductID == 1);
        surveysAvailable &&
            surveysAvailable.map(function (key, index) {
                if (index == firstDB && DBSurveys.length >= 1)
                    availableDataYears.push({ dataYear: "DB" });
                else if (index == firstDC && DCSurveys.length >= 1)
                    availableDataYears.push({ dataYear: "DC" });
                if (key.SurveyID) {
                    var suffix = "";
                    if (
                        key.ProductID == 1 &&
                        !(
                            key.DataYear == ibsStore.currentSurvey?.DataYear &&
                            key.ProductID == ibsStore.currentSurvey?.ProductID
                        )
                    ) {
                        suffix = "DB";
                    } else if (
                        key.ProductID == 2 &&
                        !(
                            key.DataYear == ibsStore.currentSurvey?.DataYear &&
                            key.ProductID == ibsStore.currentSurvey?.ProductID
                        )
                    ) {
                        //  && key.DataYear == DCSurveys[0].DataYear
                        suffix = "DC";
                    } else {
                        return;
                    }

                    availableDataYears.push({
                        surveyId: key.SurveyID,
                        dataYear: key.DataYear + surveyYearAddition + " - " + suffix,
                        productID: suffix,
                    });
                }
            });
    }

    // TODO: Add available years for IBS, needs to change depending on language, a better refactor for adding tab names in one spot (along with specifying the route perhaps
    // TODO PABS: Refactor the block
    const availablePages = () => {
        store.availPageTitles = [];

        if (store.surveyTypeUrl === SurveyTypeURL.PABS) {
            store.availPageTitles.push("Home");
            if ("start" in store.allPageResponses)
                store.availPageTitles.push(store.local.start);
            if ("members" in store.allPageResponses)
                store.availPageTitles.push(store.local.members);
            if ("costs" in store.allPageResponses)
                store.availPageTitles.push(store.local.costs);
            if ("transactions" in store.allPageResponses)
                store.availPageTitles.push(store.local.transactions);
            if ("communication" in store.allPageResponses)
                store.availPageTitles.push(store.local.communication);
            if ("customerexperience" in store.allPageResponses)
                store.availPageTitles.push(store.local.customerExperience);
            if ("voc" in store.allPageResponses)
                store.availPageTitles.push(store.local.voc);
            if ("plandesign" in store.allPageResponses)
                store.availPageTitles.push(store.local.planDesign);
        } else if (store.surveyTypeUrl === SurveyTypeURL.PABS_UK) {
            store.availPageTitles.push("Home");
            if ("start" in store.allPageResponses)
                store.availPageTitles.push(store.local.start);
            if ("members" in store.allPageResponses)
                store.availPageTitles.push(store.local.members);
            if ("costs" in store.allPageResponses)
                store.availPageTitles.push(store.local.costs);
            if ("transactions" in store.allPageResponses)
                store.availPageTitles.push(store.local.transactions);
            if ("communication" in store.allPageResponses)
                store.availPageTitles.push(store.local.communication);
            if ("customerexperience" in store.allPageResponses)
                store.availPageTitles.push(store.local.customerExperience);
            if ("plandesign" in store.allPageResponses)
                store.availPageTitles.push(store.local.planDesign);

            if ("membership" in store.allPageResponses)
                store.availPageTitles.push(store.local.membership);
            if ("actives" in store.allPageResponses)
                store.availPageTitles.push(store.local.actives);
            if ("deferreds" in store.allPageResponses)
                store.availPageTitles.push(store.local.deferreds);
            if ("pensioners" in store.allPageResponses)
                store.availPageTitles.push(store.local.pensioners);
            if ("allmembers" in store.allPageResponses)
                store.availPageTitles.push(store.local.allMember);
            if ("digital" in store.allPageResponses)
                store.availPageTitles.push(store.local.digital);
            if ("calls" in store.allPageResponses)
                store.availPageTitles.push(store.local.calls);
            if ("voc" in store.allPageResponses)
                store.availPageTitles.push(store.local.voc);
        } else if (store.surveyTypeUrl === SurveyTypeURL.PABS_LG) {
            store.availPageTitles.push("Home");
            if ("start" in store.allPageResponses)
                store.availPageTitles.push(store.local.start);
            if ("members" in store.allPageResponses)
                store.availPageTitles.push(store.local.members);
            if ("costs" in store.allPageResponses)
                store.availPageTitles.push(store.local.costs);
            if ("transactions" in store.allPageResponses)
                store.availPageTitles.push(store.local.transactions);
            if ("communication" in store.allPageResponses)
                store.availPageTitles.push(store.local.communication);
            if ("customerexperience" in store.allPageResponses)
                store.availPageTitles.push(store.local.customerExperience);
        } else if (store.surveyTypeUrl === SurveyTypeURL.DC) {
            let termsAndConditionsSigned =
                ibsStore.currentSurvey?.isAgreed ||
                ibsStore.currentSurvey?.DataYear < CURRENT_DATA_YEAR;
            store.availPageTitles.push("Home");
            if (!termsAndConditionsSigned)
                store.availPageTitles.push("Terms and Conditions");

            if (
                ibsStore.currentSurvey &&
                (termsAndConditionsSigned || checkIfAnalyst())
            ) {
                store.availPageTitles.push("Plan info");
                store.availPageTitles.push("Options");
                store.availPageTitles.push("Td&Balanced");
                store.availPageTitles.push("Admin costs");
                store.availPageTitles.push("Admin services");
                store.availPageTitles.push("Plan design");
                store.availPageTitles.push("Fiduciary");
                if (ibsStore.currentSurvey) {
                    if (ibsStore.currentSurvey?.PlanPartnershipID == 2) {
                        store.availPageTitles.push("Employer stock");
                    }
                }

                var isValidated = false;

                if (
                    typeof ibsStore.currentSurvey !== "undefined" &&
                    typeof ibsStore.currentSurvey?.SurveyStatusID !== "undefined"
                ) {
                    //not sure all the 'validated' status

                    isValidated = ibsStore.currentSurvey?.SurveyStatusID != null; //any validated value, could also be null
                }

                if (isValidated || store.currentSurvey?.IsLocked) {
                    store.availPageTitles.push("Unlock");
                    store.availPageTitles.push("Results");
                } else {
                    store.availPageTitles.push("Submit");
                }

                if (store.printMode === true) {
                    store.availPageTitles.push("Print");
                }
            }
        } else if (store.surveyTypeUrl === SurveyTypeURL.DB) {
            let termsAndConditionsSigned =
                ibsStore.currentSurvey?.isAgreed ||
                ibsStore.currentSurvey?.DataYear < CURRENT_DATA_YEAR;
            store.availPageTitles.push("Home");
            if (!termsAndConditionsSigned)
                store.availPageTitles.push("Terms and Conditions");

            if (
                ibsStore.currentSurvey &&
                (termsAndConditionsSigned || checkIfAnalyst())
            ) {
                store.availPageTitles.push("Plan info");
                store.availPageTitles.push("Assets");
                if ([4, 5, 6].includes(ibsStore.currentSurvey?.EnhancedInternalID)) {
                    store.availPageTitles.push("Custom groupings");
                }
                store.availPageTitles.push("Benchmarks");
                store.availPageTitles.push("Expenses");

                if (ibsStore.currentSurvey) {
                    if (
                        !(
                            ibsStore.currentSurvey?.PlanPartnershipID === 6 ||
                            ibsStore.currentSurvey?.PlanPartnershipID === 7
                        )
                    ) {
                        store.availPageTitles.push("Liability");
                    }
                }

                if (ibsStore.accountInfo && ibsStore.currentSurvey) {
                    let isMandateLevel = getSurveyResponseValue("IsMandateLevel");
                    if (
                        `${isMandateLevel}` === "1" ||
                        `${isMandateLevel}` === "2" ||
                        !isUK()
                    ) {
                        store.availPageTitles.push("Ltd partnerships");
                    }
                }

                if (showTemplates()) {
                    store.availPageTitles.push("Templates");
                }

                var isValidated = false;

                if (
                    typeof ibsStore.currentSurvey !== "undefined" &&
                    typeof ibsStore.currentSurvey?.SurveyStatusID !== "undefined"
                ) {
                    //not sure all the 'validated' status

                    isValidated =
                        ibsStore.currentSurvey?.SurveyStatusID != null &&
                        ibsStore.currentSurvey?.SurveyStatusID != 0; //any validated value, could also be null
                }

                if (isValidated || store.currentSurvey?.IsLocked) {
                    store.availPageTitles.push("Unlock");
                    store.availPageTitles.push("Results");
                } else {
                    store.availPageTitles.push("Submit");
                }

                if (store.printMode === true) {
                    store.availPageTitles.push("Print");
                }
            }
        }

        const navItems = store.availPageTitles.map((page) => (
            <>
                {page != null && (
                    <NavLink
                        tag={Link}
                        to={
                            store.surveyTypeUrl + page.replaceAll(" ", "").replaceAll("&", "")
                        }
                        className={formattedPage(page) ? "activeNavLink" : ""}
                    >
                        {pageNameDisplayOverride(page)}
                    </NavLink>
                )}
            </>
        ));

        return navItems;
    };

    const formattedPage = (page) => {
        return (
            store.currentLandedPage.replaceAll("_", "") === page.toLowerCase().replaceAll(" ", "") ||
            store.currentLandedPage.replaceAll("_", "") === page.toLowerCase().replaceAll("&", "")
        );
    };

    //This part needs to be refactored after  fixing the sql for getting the current survey information, orgname is null atm
    let organizationName = "";
    if (isPabsSurveyType && store.availablePlanProducts) {
        const result = store.availablePlanProducts.filter(word => word.PlanId === store.currentSurvey?.SystemId);
        organizationName = result[0]?.OrgName
        if (UserStore.accountInfo.isAnalyst) {
            const result = store.pabsSurveysList.filter(word => word.SurveyId == store.currentSurvey?.SurveyId);
            organizationName = result[0]?.OrgName
        }
    } else if (isIbsSurveyType) {
        organizationName = ibsStore.currentSurvey?.PlanSponsor
        if (!organizationName) {
            organizationName = ibsStore.currentSurvey?.Plan
        }
    } else {
        organizationName = ibsStore.accountInfo?.PlanSponsor
    }
    //need to distinguish types of surveys
    let currentSuffix = '';
    if (ibsStore.currentSurvey && ibsStore.currentSurvey?.ProductID === 1)
        currentSuffix = "DB"
    else {
        if (store.surveyTypeUrl === SurveyTypeURL.DB)
            currentSuffix = "DB";
        else if (store.surveyTypeUrl === SurveyTypeURL.DC)
            currentSuffix = "DC";
    }

    if (isIbsSurveyType && !ibsStore.accountInfo) {
        getIbsAccountInfo();
    }

    let surveyInfoSection = <></>
    let laundromatAndRecentActivitiesSection = <></>;
    let printButton = <></>
    if (isIbsSurveyType) {
        surveyInfoSection =
            <div style={{ marginTop: "8px" }}>
                <span className="orgName"> {organizationName} </span>
                {checkIfAnalyst() &&
                    <span style={{ fontSize: "70%" }}>
                        | Plan {ibsStore?.currentSurvey?.PlanID ?? ""} | Survey {ibsStore?.currentSurvey?.SurveyID ?? ""}
                    </span>
                }
            </div>
        laundromatAndRecentActivitiesSection =
            <>
                <div style={{ margin: '8px 0px 0px 0px' }}>
                    <Link to={`${store.surveyTypeUrl}laundromat`}>
                        <i id="LaundromatNavButton" className="fas fa-folder-open" title="Laundromat"></i>
                    </Link>
                </div>

                <div style={{ margin: '8px 0px 0px 0px' }}>
                    <i id="ProductionNavButton" className="fas fa-cogs" title="Production"
                        onClick={() => openInNewTab("https://production.cembenchmarking.com/ui/")}></i>
                </div>


                <div style={{ margin: '8px 0px 0px 0px' }}>
                    <Link to={`${store.surveyTypeUrl}recentActivities`}>
                        <i id="RecentActivitiesNavButton" className="fas fa-clock" title="Recent Activities"></i>
                    </Link>
                </div>
            </>
        printButton =
            <div style={{ margin: '8px 0px 0px 0px' }}>
                <i id="PrintNavButton" className="fas fa-print" title="Print" style={(store.printMode) ? { color: "#1a71c1" } : { color: "#95b6c7" }}
                    onClick={() => {
                        if (store.currentLandedPage !== "print") {
                            store.printMode = !store.printMode;
                        }
                    }}>
                </i>
            </div>
    }

    if (isPabsSurveyType) {
        surveyInfoSection =
            <div>
                {(store.availablePlanProducts?.length > 1) ?
                    <DropDownList
                        className="orgSelectDropdown"
                        onChange={handlePlanChangePABS}
                        data={store.availablePlanProducts?.filter(plan => plan.PlanId != null && plan.OrgName != null)}
                        dataItemKey="PlanId"
                        textField="OrgName"
                        value={{
                            OrgName: organizationName,
                            PlanID: store?.currentSurvey?.SystemId
                        }}
                        popupSettings={{ className: "kendoDropdownMaxContentWidth" }}
                        itemRender={(li, itemProps) => {
                            let availableSurveysWithPlan = store.allAvailableSurveys?.filter((survey) => { return survey.SystemId === itemProps.dataItem.PlanId });
                            let disabled = false;
                            let elemStyle = {};

                            if (store?.currentSurvey?.SystemId === itemProps.dataItem.PlanId) {
                                elemStyle.fontWeight = "bold";
                                disabled = true
                            }
                            if (availableSurveysWithPlan?.length <= 0) {
                                elemStyle.textColor = "red";
                                disabled = true
                            }

                            const itemChildren = <span style={ elemStyle } >
                                {itemProps.dataItem.OrgName}
                            </span>;
                            return React.cloneElement(li, {
                                ...li.props,
                                style: {
                                    ...li.props.style,
                                },

                                className: disabled ? ('k-state-disabled ' + li.props?.className) : li.props?.className
                            }, itemChildren);
                        }}

                    ></DropDownList>
                    :
                        <span className="orgName" style={{ marginTop: "8px" }}> {organizationName} </span>
                    }

                {checkIfAnalyst() &&
                    <span style={{fontSize: "70%"}}>
                        | Plan {store?.currentSurvey?.SystemId ?? ""} | Survey {store?.currentSurvey?.SurveyId ?? ""}
                    </ span>
                }
            </div>
        laundromatAndRecentActivitiesSection =
            <>
                <div style={{margin: '8px 0px 0px 0px'}}>
                <Link to={`${store.surveyTypeUrl}laundromat`}>
                    <i
                        id="LaundromatNavButton"
                        className="fas fa-folder-open"
                        title="Laundromat"
                    ></i>
                </Link>
                </div>
            </>
    }

  const classes = [
    "navbar",
    "navbar-expand-md",
    "fixed-top-sm",
    "justify-content-start",
    "flex-nowrap",
    "navbar-dark",
  ];

    if (process.env.REACT_APP_IDENTITY === "IDENTITY_CONFIG_INTRA") {
        classes.push("bg-grey-red");
    } else {
        classes.push("bg-grey");
    }

    const isCiebaPartnership = ibsStore.currentSurvey?.PlanPartnershipID === 2;
    
    return (
        <div className="fixed-top" data-toggle="affix">
            <nav className={classes.join(" ")}>
                <a className="" href={store.surveyTypeUrl + "home"}>
                    <img className={isCiebaPartnership ? "logo" : "logoDefault"} src={isCiebaPartnership ? logoCIEBA : logowhite}  alt='logo'/> &nbsp;
                </a>
                <div className="pull-right">
                    {store.currentSurvey && (store.currentSurvey?.IsReadOnly || !store.userCanEditReadOnlySurvey) &&
                        <span className="readonly-notif">Note: This survey is read-only.</span>
                    }
                    
                    {surveyInfoSection}

                    {((userStore.accountInfo && userStore.accountInfo.isAnalyst)
                            || (ibsStore.accountInfo && ibsStore.accountInfo.UserRoleID == 3))
                        && laundromatAndRecentActivitiesSection}
                    
                    <DropDownList
                        className="yearSelectDropdown"
                        onChange={handleYearChange}
                        data={availableDataYears}
                        dataItemKey="surveyId"
                        textField="dataYear"
                        value={{
                            dataYear:
                                currentDataYear +
                                surveyYearAddition +
                                (currentSuffix ? " - " : "") +
                                currentSuffix,
                        }}
                    ></DropDownList>
                    
                    {printButton}
                    <div style={{margin: '8px 0px 0px 0px'}}>
                        <i onClick={triggerHelpModal} className="fa fa-question-circle" title="Help & Contact"></i>
                    </div>
                    <div style={{margin: '8px 0px 0px 0px'}}>
                        <i onClick={triggerLogoutPanel} className="fas fa-sign-out-alt" title="Logout"></i>
                    </div>

                    {((userStore.accountInfo && userStore.accountInfo.isAnalyst) ||
                        (ibsStore.accountInfo && ibsStore.accountInfo.UserRoleID == 3)) && (
                        <UncontrolledDropdown className="settingsDropdown">
                            <DropdownToggle>
                                <i className="fas fa-bars"></i>
                            </DropdownToggle>

                            <DropdownMenu right>
                                <React.Fragment>
                                    <DropdownItem onClick={triggerDeveloperMode}>
                                        <i className="fa fa-solid fa-microchip"></i>
                                        Developer Info
                                    </DropdownItem>

                                    {isPabsSurveyType &&
                                        <DropdownItem onClick={() => { window.open("https://production.cembenchmarking.com/ui/") }}>
                                            <i className="fas fa-cogs"></i>
                                            Open Production
                                        </DropdownItem>
                                    }
                                    <DropdownItem onClick={triggerQuestionMode}>
                                        <i
                                            className={
                                                store.questionMode
                                                    ? "far fa-eye iconModeOn"
                                                    : "far fa-eye"
                                            }
                                        ></i>
                                        Question Mode
                                    </DropdownItem>

                                    <DropdownItem onClick={triggerAnalystMode}>
                                        <i
                                            className={
                                                store.analystMode
                                                    ? "fa fa-user-cog iconModeOn"
                                                    : "fa fa-user-cog "
                                            }
                                        ></i>
                                        Analyst Mode
                                    </DropdownItem>

                                    <DropdownItem onClick={triggerValidateForAdmin}>
                                        <i className={"fa fa-check-double "}></i>
                                        Validate for Admin
                                    </DropdownItem>
                                </React.Fragment>

                            </DropdownMenu>
                        </UncontrolledDropdown>
                    )}

                </div>
                <button className="navbar-toggler ml-auto" type="button" data-toggle="collapse" data-target="#navbar2">
                    <span className="navbar-toggler-icon"></span>
                </button>
            </nav>
            <nav className="navbar navbar-expand-md bottom-nav " align="center">
                <div className="navbar-collapse collapse pt-2 pt-md-0" id="navbar2">
                    <span style={{ width: '2000px', margin: '0 auto' }}>
                        {availablePages()}
                        {/* TODO this should be added in availablePages instead and automatically added here. why is there a special case inside the jsx*/}
                        {/* There is nothing special in the jsx for submit */}
                        {store.currentSurvey &&
                            store.currentSurvey?.DataYear == sharedStore.currentDataYear &&
                            !store.currentSurvey.IsReadOnly &&
                            userStore.isPlanAdministrator(store.currentSurvey?.SystemId) &&
                            !window.location.pathname.includes("laundromat") &&  (
                                <React.Fragment>
                                    <NavLink
                                        tag={Link}
                                        to={store.surveyTypeUrl + store.local.submit}
                                        className={store.currentLandedPage == "submit" ? "activeNavLink" : ""}
                                    >
                                        {" "}
                                        Submit
                                    </NavLink>
                                </React.Fragment>
                            )}
                    </span>
                </div>
            </nav>
        </div>
    );
});
export default NavMenu;